import React from "react";
import { Formik, Form } from "formik";
import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn } from "../Styles/InputStyles";

const DeactivateStaff = ({
    selectedData,
    setIsDeactivateStaff,
    deactivateStaffLoading,
    deactivateStaffMutate,
}) => {
    // const handleDeactivateSubmit = () => {
    //     deactivateStaffMutate({ staffId: selectedData?.id });
    // };
    const handleDeactivateSubmit = () => {
    deactivateStaffMutate({
        id: selectedData?.id,
        // status: selectedData?.status === 1 ? 2 : 1,
        status: selectedData?.status,
    });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeactivateStaff}
            title={
                selectedData?.status === 2
                    ? "Inactivate Staff Confirmation"
                    : "Activate Staff Confirmation"
            }
        >
            <WarningText>
                Are you sure you want to{" "}
                {selectedData?.status === 2 ? "inactivate" : "activate"}{" "}
                {selectedData?.name}
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsDeactivateStaff(false)}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleDeactivateSubmit}
                    disabled={deactivateStaffLoading}
                    className={`border ${selectedData.status === 2
                            ? "border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                            : "border-green-500 bg-white text-green-500 hover:bg-green-500 hover:text-white"
                        }`}
                >
                    {deactivateStaffLoading ? "Loading..." : "Confirm"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;
const SubmitBtn = tw.button`rounded-md shadow-md  border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base`
export default DeactivateStaff;
